import React, { useState } from "react";
import { Button, Checkbox, Modal, notification } from "antd";
import { agreeToTerms } from "../../api/users";

export const TermsAndConditionsModal = ({ isOpen }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [hasAccepted, setHasAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const agreeToTermsAndConditions = async () => {
    try {
      setIsLoading(true);
      await agreeToTerms();
      setHasAccepted(true);
      notification.success({
        message: "Successful agreement to our Terms and Conditions.",
      });
    } catch (e) {
      notification.error({
        message: "Oops, something went wrong. Please try later.",
      });
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      closeIcon={<></>}
      title={<h3 className="text-center"> Terms and Conditions Agreement </h3>}
      open={isOpen && !hasAccepted}
      footer={null}
    >
      <span>
        To continue using this application, you must read and accept our{" "}
        <a
          href="https://teamsunday.com/legal/terms-and-conditions/"
          target="_blank"
        >
          Terms & Conditions
        </a>{" "}
        and{" "}
        <a href="https://teamsunday.com/legal/privacy-policy/" target="_blank">
          Privacy Policy.
        </a>
      </span>

      <div>
        <Checkbox
          onChange={(e) => setIsChecked(e.target.checked)}
          className="mt-2 w-100"
        >
          <h5>
            I have read and agree to the Terms & Conditions and Privacy Policy
          </h5>
        </Checkbox>
      </div>

      <Button
        className="mt-3 w-100"
        type="primary"
        disabled={!isChecked}
        loading={isLoading}
        onClick={agreeToTermsAndConditions}
      >
        Accept and Continue
      </Button>
    </Modal>
  );
};
